import EntityLayer from 'app/containers/Maps/EntityLayerStyling/EntityLayer';
import Cluster from 'ol/source/Cluster';
import { bind } from 'app/utils/decorators/decoratorUtils';
import { get } from 'app/utils/lo/lo';
import { clusterStyle } from 'app/components/molecules/Map/EntityPin/entityPinStyle';
import { calculateSubLayerZIndex, applyLayerZIndex } from 'app/config/layerZIndexConfig';

class ClusterLayer extends EntityLayer {
    clusterSource = null;

    constructor(info, map) {
        super(info, map);
        
        const parentZIndex = this.zIndex;
        const entityZIndex = calculateSubLayerZIndex(parentZIndex);
        
        if (typeof info?.originalZIndex === 'number') {
            this.originalZIndex = info.originalZIndex;
        }
        
        applyLayerZIndex(this.layer, entityZIndex);
        this.entityZIndex = entityZIndex;
        
        this.info = { 
            ...this.info, 
            zIndex: parentZIndex,
            entityZIndex: entityZIndex
        };
        this.layer.setSource(this.getClusterSource());
        const pinStyle = this.info?.styleType || this.info?.styles?.pinStyle || 'cluster';
        if (pinStyle !== 'hideEntities') {
            this.layer.setStyle(this.styleFunction);
        }
    }

    @bind
    styleFunction(feature, resolution) {
        const { styles } = this.info;
        const pinStyle = styles?.pinStyle || this.info?.styleType || 'cluster';
        const features = feature && feature.get('features');
        
        const baseZIndex = this.zIndex;
        
        if (pinStyle === 'cluster' && features && features.length > 1) {
            return clusterStyle(features, false, baseZIndex);
        } else if (feature) {
            return this.createDefaultStyle(feature);
        }
    }

    @bind
    getClusterSource() {
        const distance = get(this.info?.styles, 'distance' || 120);
        if (!this.clusterSource) {
            this.clusterSource = new Cluster({
                distance: distance,
                source: this.getDataSource(),
            });
        }
        return this.clusterSource;
    }

    @bind
    updateClusterSource(distance) {
        this.clusterSource.setDistance(distance);
    }
    
    /**
     * Updates the z-index based on original parent z-index if available
     */
    @bind
    updateZIndex() {
        const baseZIndex = this.parentOriginalZIndex || this.zIndex;
        const clusterZIndex = calculateSubLayerZIndex(baseZIndex);
        
        this.entityZIndex = clusterZIndex;
        applyLayerZIndex(this.layer, clusterZIndex);
        return clusterZIndex;
    }

    /**
     * Stores the parent layer's original z-index for preserving correct hierarchy
     */
    storeParentOriginalZIndex(originalZIndex) {
        if (typeof originalZIndex === 'number') {
            this.parentOriginalZIndex = originalZIndex;
            this.updateZIndex();
        }
    }
}

export default ClusterLayer;
